import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";

export const useCustomPagesStore
    = defineStore('customPagesStore', () => {


    const crud = useCrudStore();
    const endpoint = environment.appConfig.baseApiUrl + "custom-page";


    async function loadCustomPage({page_slug}) {
        console.log("loadCustomPage");
        crud.startLoading();
        // Ищу, может уже есть с таким ID
        const found = crud.data?.find(item => item.slug === page_slug);
        if(found) {
            crud.clearLoading();
            crud.setRecord(found);
            return;
        }
        try {
            const params = {page_slug};
            const resp = await httpClient.get(endpoint, {params});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.addItems([resp.data.custom_page])
            crud.setRecord(resp.data.custom_page);
            crud.clearLoading();
        }catch (e) {
            crud.setError(e);
        }
    }

    async function loadCustomPagesByPrefix(slugPrefix) {
        crud.startLoading();
        try {
            const resp = await httpClient.get(endpoint.replace('custom-page', 'custom-pages'), {
                params: {slug_prefix: slugPrefix}
            });
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return [];
            }
            const pages = resp.data.custom_pages || [];
            crud.addItems(pages);
            crud.clearLoading();
            return pages;
        } catch (e) {
            crud.setError(e);
            return [];
        }
    }

    async function loadClubFaq() {
        const pages = await loadCustomPagesByPrefix('club-faq');
        crud.setData(pages);
    }
    return {
        ...crud,
        loadCustomPage,
        loadCustomPagesByPrefix,
        loadClubFaq,
    }
});
